import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewEncapsulation,
    signal,
    ViewChild,
    computed,
    output,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25ReportFileTypeComponent } from "../../standalone/s25.report.file.type.component";
import { S25ReportOutputFileNameComponent } from "../../standalone/s25.report.output.file.name.component";
import { S25CheckboxModule } from "../s25-checkbox/s25.checkbox.module";
import { FileUploadModule } from "../s25-file-upload/s25.file.upload.module";
import { S25LoadingApi } from "../s25-loading/loading.api";
import { LangService } from "../../services/lang.service";
import { DataAccess } from "../../dataaccess/data.access";
import { EventService } from "../../services/event.service";
import { S25Util } from "../../util/s25-util";
import { S25Const } from "../../util/s25-const";
import { ContactService } from "../../services/contact.service";
import { UserprefService } from "../../services/userpref.service";
import { EventEmailService } from "../../services/event.email.service";
import { BpeService } from "../bpe/bpe.service";
import { FlsService } from "../../services/fls.service";
import { DocumentService } from "../../services/document.service";
import { PreferenceService } from "../../services/preference.service";
import { Report } from "../../pojo/Report";
import { TelemetryService } from "../../services/telemetry.service";
import { EmailService, EmailReport, EmailRecipientInput } from "../../services/email.service";
import { NotificationService } from "../../services/notification.service";
import { LoginService } from "../../services/login.service";
import {
    EventEmailDataI,
    EmailsConfig,
    EmailRole,
    EmailReportSimpleObject,
    EmailReportObject,
    EmailField,
} from "../../pojo/EventEmailDataI";
import { S25File, FileList } from "../s25-file-upload/s25.file.upload.component";
import { AttachmentService } from "../../services/attachment.service";
import { S25ItemI } from "../../pojo/S25ItemI";
import { ObjectDetailsUtil } from "../../util/object.details.util";
import ReportFormat = Report.ReportFormat;
import { ReportService } from "../../services/report.service";
import { S25LoadingInlineModule } from "../s25-loading/s25.loading.inline.module";
import { S25MultiselectModule } from "../s25-multiselect/s25-multiselect.module";
import { S25RichTextEditorModule } from "../s25-rich-text-editor/s25.rich.text.editor.module";

@TypeManagerDecorator("s25-ng-email-event")
@Component({
    selector: "s25-ng-email-event",
    template: `
        <div class="moreActionsEmail">
            <div>
                <s25-loading-inline [model]="{}"></s25-loading-inline>
            </div>

            @if (init && data.init) {
                @if (data.templates.length > 0) {
                    <div class="c-margin-bottom--single">
                        @if (data.profiles.length > 1) {
                            <label>
                                Segment:
                                <select
                                    class="cn-form__control"
                                    [(ngModel)]="data.chosenProfile"
                                    (ngModelChange)="chooseProfile($event)"
                                >
                                    <option [ngValue]="allProfiles">{{ allProfiles.profile_name }}</option>
                                    @for (item of data.profiles; track item.profile_id) {
                                        <option [ngValue]="item">{{ item.profile_name }}</option>
                                    }
                                </select>
                            </label>
                        }

                        <label>
                            <strong class="c-margin-right--quarter">Email Template</strong>
                            <select
                                class="cn-form__control"
                                [(ngModel)]="data.chosenTemplate"
                                (ngModelChange)="chooseTemplate($event)"
                            >
                                @for (item of data.templates; track "temp_" + item.itemId) {
                                    <option [ngValue]="item">{{ item.itemName }}</option>
                                }
                            </select>
                        </label>
                    </div>
                }

                <div class="email-details--wrapper">
                    <div>
                        @if (!hasGlobalFrom && data.canFrom && !data.fromEmail && !data.showFrom) {
                            <button
                                (click)="addFrom()"
                                class="aw-button aw-button--primary c-margin-bottom--single c-margin-top--half"
                            >
                                Add Custom From Address
                            </button>
                        }

                        @if (
                            (data.canFrom && data.fromEmail && data.showFrom) ||
                            (data.canFrom && !data.fromEmail && data.showFrom)
                        ) {
                            <label class="c-margin-bottom--single c-margin-top--half">
                                <strong>From Address:</strong>
                                <input
                                    aria-label="from address"
                                    type="text"
                                    name="from"
                                    [(ngModel)]="data.fromEmail"
                                    class="c-input"
                                />
                            </label>
                        } @else if (!data.canFrom && data.fromEmail) {
                            <label class="c-margin-bottom--single c-margin-top--half">
                                <strong>From Address:</strong>
                                <span class="c-padding-left--half">{{ data.fromEmail }}</span>
                            </label>
                        }

                        <p>
                            <strong>{{ data?.emailLang?.text?.related_recipients }}:</strong>
                        </p>
                        <table border="0" cellspacing="5" width="90%">
                            <thead>
                                <tr align="center">
                                    <th></th>
                                    <th width="34">{{ data?.emailLang?.text?.to }}</th>
                                    <th width="34">{{ data?.emailLang?.text?.cc }}</th>
                                    <th width="34">{{ data?.emailLang?.text?.bcc }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (role of data.roles; let i = $index; track "role_" + i) {
                                    <tr align="center">
                                        <th align="left" class="c-padding-bottom--half font--normal">
                                            @if (!role.text) {
                                                <ng-container>
                                                    <span>{{ role.roleName }}</span>
                                                    <p style="font-weight: normal">({{ role.contactName }})</p>
                                                    @if (!role.email) {
                                                        <div class="cn-alert cn-alert--danger">Invalid Email</div>
                                                    }
                                                </ng-container>
                                            }
                                            @if (role.text) {
                                                <ng-container>{{ role.text }}</ng-container>
                                            }
                                        </th>
                                        <td>
                                            <s25-ng-checkbox
                                                [(value)]="role.isChosenTo"
                                                aria-label="role email"
                                                [disabled]="!role.email"
                                            >
                                            </s25-ng-checkbox>
                                        </td>
                                        <td>
                                            <s25-ng-checkbox
                                                [(value)]="role.isChosenCC"
                                                aria-label="role email"
                                                [disabled]="!role.email"
                                            >
                                            </s25-ng-checkbox>
                                        </td>
                                        <td>
                                            <s25-ng-checkbox
                                                [(value)]="role.isChosenBCC"
                                                aria-label="role email"
                                                [disabled]="!role.email"
                                            >
                                            </s25-ng-checkbox>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    <div class="email-details--recipients-reports">
                        <div class="email-details--additional-recipients c-margin-right--single">
                            <p>
                                <strong>{{ data?.emailLang?.text?.additional_recipients }}:</strong>
                            </p>
                            <!-- additional contacts -->

                            @for (field of emailFields; track field.id) {
                                <div class="c-margin-bottom--single c-margin-top--single">
                                    <s25-ng-multiselect-search-criteria
                                        [type]="'contacts'"
                                        [popoverOnBody]="true"
                                        [buttonText]="field.buttonText"
                                        [modelBean]="field.model"
                                        [useSecurity]="true"
                                        [popoverPlacement]="'bottom-left top-left top left'"
                                    ></s25-ng-multiselect-search-criteria>

                                    <input
                                        [attr.aria-label]="field.label + ' Emails'"
                                        [id]="field.id"
                                        type="text"
                                        [name]="field.id"
                                        [(ngModel)]="field.model.emailList"
                                        class="c-input input-spacer"
                                    />
                                </div>
                            }

                            <div class="ngFinePrint" style="width:260px">
                                {{ data?.emailLang?.text?.separate_with_commas }}
                            </div>
                        </div>

                        <div class="tblReports c-margin-left--half">
                            <p width="10%" align="left" valign="top" style="padding-top:5px">
                                <strong>{{ data?.emailLang?.text?.attach_file }}</strong>
                            </p>
                            <div style="padding-top:5px" class="email-details-attach-list">
                                <!-- actual reports -->
                                @for (report of data.reports; track report.emailListKey) {
                                    <div class="report">
                                        <s25-ng-checkbox
                                            [(value)]="report.isChosen"
                                            (valueChange)="onReportChosenChange(report, $event)"
                                        >
                                            {{ report.rpt_name }}
                                        </s25-ng-checkbox>

                                        @if (
                                            report.isChosen &&
                                            report.object_type === 13 &&
                                            data.organizations.length > 1
                                        ) {
                                            <label>
                                                Choose an Organization:
                                                <select
                                                    class="form-control"
                                                    [(ngModel)]="report.orgId"
                                                    (change)="onReportOrgChange(report)"
                                                >
                                                    <option [ngValue]="undefined">All Organizations</option>
                                                    @for (org of data.organizations; track org.organization_id) {
                                                        <option [ngValue]="org.organization_id">
                                                            {{ org.organization_name }}
                                                        </option>
                                                    }
                                                </select>
                                            </label>
                                        }

                                        @if (
                                            report.isChosen &&
                                            (report.rpt_engine === "JR" || report.report_engine === "JR")
                                        ) {
                                            <s25-ng-report-file-type
                                                [reportId]="report.emailListKey"
                                                [formatType]="report.format || 2"
                                                (modelValueChange)="
                                                    onReportFormatChange($event);
                                                    getReportOutputFilename(report.emailListKey)
                                                "
                                            >
                                            </s25-ng-report-file-type>
                                        }

                                        @if (report.isChosen) {
                                            <s25-ng-report-output-file-name
                                                [reportId]="report.emailListKey"
                                                [reportFilenameInput]="getReportOutputFilename(report.emailListKey)"
                                                [eventData]="$safeNavigationMigration(data?.eventData)"
                                                (modelValueChange)="onReportFilenameChange($event)"
                                            >
                                            </s25-ng-report-output-file-name>
                                        }
                                    </div>
                                }

                                <!-- web service reports -->
                                <div class="report">
                                    <s25-ng-checkbox [(value)]="data.iCalReport" aria-label="icare Report">
                                        iCal File
                                    </s25-ng-checkbox>
                                </div>

                                @if (eventFiles.length > 0) {
                                    <span> {{ eventFiles.length > 1 ? "Event Files:" : "Event File:" }} </span>
                                    @for (file of eventFiles; track "file" + "-" + i; let i = $index) {
                                        <div class="c-margin-left--single">
                                            <s25-ng-checkbox [(value)]="file.isChosen" aria-label="file?.itemName">
                                                {{ file?.itemName }}
                                                @if (file?.cust_atrb_id) {
                                                    <span class="small"> (custom attribute file)</span>
                                                }
                                            </s25-ng-checkbox>
                                        </div>
                                    }
                                }

                                <!-- uploaded files -->
                                <s25-ng-file-upload [showFiles]="true" [onAdd]="handleFileUpload" [multiple]="true">
                                </s25-ng-file-upload>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ngWidth100 c-margin-top--half">
                    <label for="emailSubject" class="ngBold">{{ data?.emailLang?.text?.subject }}</label>
                    <input
                        aria-label="email subject"
                        id="emailSubject"
                        type="text"
                        name="subject"
                        style="width:100%;"
                        [(ngModel)]="data.subject"
                        class="c-input"
                    />

                    <s25-ng-checkbox
                        [(value)]="data.includeLink"
                        (valueChange)="onLinkChange($event)"
                        aria-label="include Link"
                    >
                        Include link to 25Live
                    </s25-ng-checkbox>
                </div>

                <div class="c-margin-top--half">
                    <div>
                        <label class="ngBold">{{ data?.emailLang?.text?.message_body }}</label>
                        <span class="emailTip ngFinePrint" style="margin-left:25px">
                            {{ data?.emailLang?.text?.event_details_instructions }}
                        </span>
                    </div>

                    <s25-ng-rich-text-editor [(modelValue)]="data.bodyMsg" [autoResize]="true">
                    </s25-ng-rich-text-editor>

                    <s25-ng-checkbox [(value)]="data.isIncludeDetails" aria-label="isInclude Details">
                        Include event details in body of message
                    </s25-ng-checkbox>
                </div>

                <div class="scenarioRow">
                    <s25-ng-checkbox
                        [(value)]="isScheduled"
                        (valueChange)="onScheduledChange($event)"
                        aria-label="isScheduled"
                    >
                        Scheduled Email
                    </s25-ng-checkbox>
                </div>

                @if (isScheduled) {
                    <div class="scenarioRow">
                        <label>
                            Schedule Type:
                            <select [(ngModel)]="scheduleType" class="cn-form__control">
                                <option value="daysFromEventStart">Days after Event Start</option>
                                <option value="daysFromEventEnd">Days after Event End</option>
                                <option value="daysFromNow">Days from Now</option>
                            </select>
                        </label>

                        <label>
                            Schedule Offset Days:
                            <input type="number" class="c-input" [(ngModel)]="scheduleDays" />
                        </label>
                    </div>
                }

                @if (data.canFrom && !isScheduled) {
                    <div class="scenarioRow">
                        <s25-ng-checkbox [(value)]="isConvo" aria-label="Enable conversation threading">
                            Enable conversation threading
                        </s25-ng-checkbox>
                    </div>
                }
            }

            <div class="aw-button-group">
                <button class="aw-button aw-button--outline" (click)="cancel()">Cancel</button>
                <button class="aw-button aw-button--primary" (click)="getReportRunItemID()" [disabled]="disabled">
                    {{ data?.emailLang?.text?.send_button }}
                </button>
            </div>
        </div>
    `,
    styles: `
        .input-spacer {
            margin-left: 8px;
        }

        .c-emailOnly-editableRecipients {
            border-bottom: 1px dotted currentColor;
            color: #2573a7;
            color: var(--color-primary);
            line-height: 1;
            outline-offset: 2px;
            font-weight: 400;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        S25LoadingInlineModule,
        FormsModule,
        S25CheckboxModule,
        S25MultiselectModule,
        S25ReportFileTypeComponent,
        S25ReportOutputFileNameComponent,
        FileUploadModule,
        S25RichTextEditorModule,
    ],
})
export class S25EmailEventComponent implements OnInit {
    @Input() itemId: number;

    readonly closed = output();

    init: boolean = false;

    data: Partial<EventEmailDataI> = {};
    isScheduled: 0 | 1;
    isConvo: 0 | 1 = 0;
    scheduleType: "daysFromEventStart" | "daysFromEventEnd" | "daysFromNow" = undefined;
    scheduleDays: number = undefined;
    reportsEventContractIsChosen: EmailReportSimpleObject[];
    disabled = false;
    hasGlobalFrom: boolean;
    eventFiles: S25File[] = [];
    emailFields: EmailField[];

    allProfiles = { profile_name: "ALL", profile_id: -999 };

    dataSignal = signal<Partial<EventEmailDataI>>({});
    private emailReportKeySeq = 0;

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {
        this.elementRef.nativeElement.angBridge = this;
    }

    async ngOnInit() {
        try {
            this.setLoading(true);

            const lang = await LangService.getLang();
            this.data.lang = lang || undefined;
            this.data.files = [];
            this.data.eventLinkFormat = "pro";
            this.data.includeLink = true;
            this.data.emailLang = lang.div.controls["s25-evdetails_email"];
            this.data.ToEmails = { title: this.data?.emailLang?.text?.to, contactRefsByEmail: {} };
            this.data.CCEmails = { title: this.data?.emailLang?.text?.cc, contactRefsByEmail: {} };
            this.data.BCCEmails = { title: this.data?.emailLang?.text?.bcc, contactRefsByEmail: {} };
            this.data.rteId = "messageBodyId-" + Date.now();

            const [
                eventData,
                reportsData,
                dateFormat,
                timeFormat,
                loginData,
                currentEmail,
                sessionId,
                templates,
                fls,
                contracts,
                prefs,
                orgContracts,
                eventTypeReports,
                eventFiles,
            ] = await Promise.all([
                EventService.getEventInclude(this.itemId as number, [
                    "customers",
                    "workflow",
                    "reservations",
                    "organizations",
                ]),
                EventService.getEventReports(this.itemId as number),
                UserprefService.getS25Dateformat(),
                UserprefService.getS25Timeformat(),
                LoginService.getLoginCached(),
                ContactService.getCurrentEmail(),
                UserprefService.getSessionId(),
                BpeService.getManualTemplates(),
                FlsService.getFls(),
                DocumentService.getDocumentList({ type: "event" }),
                PreferenceService.getPreferences(["EmailFromAddress"], "S"),
                DocumentService.getDocumentList({ type: "organization" }),
                EventService.getEventTypeReports(),
                AttachmentService.getFileList(1, this.itemId),
                this.data.ToEmails.dataPromise,
                this.data.CCEmails.dataPromise,
                this.data.BCCEmails.dataPromise,
            ]);

            this.hasGlobalFrom = !!prefs?.["EmailFromAddress"]?.value;
            Object.assign(this.data as EventEmailDataI, {
                eventData,
                reportsData,
                dateFormat,
                timeFormat,
                loginData,
                currentEmail,
                sessionId,
                templates,
                fls,
                contracts,
                prefs,
                orgContracts,
                eventTypeReports,
            });

            const contactId = loginData.userId;
            this.data.profiles = S25Util.array.forceArray(eventData.profile);
            this.data.organizations = S25Util.array.forceArray(eventData.organization);

            // Profile selection
            if (this.data && this.data?.profiles?.length > 1) {
                this.data.chosenProfile = this.allProfiles;
            } else {
                this.data.chosenProfile = this.data?.profiles[0];
            }

            this.data.canFrom = fls.EMAIL_OPTIONS === "F";
            this.data.templates = ["R", "C", "F"].includes(fls.SYS_TEMPLATE) ? templates : [];
            this.data.sessionId = sessionId;
            this.data.sender = loginData.contactName;
            this.data.subject = `${eventData.event_name} (${eventData.event_locator})`;
            this.data.subjectClean = this.data?.subject;

            this.data.roles = [];
            if (currentEmail) {
                this.data?.roles.push({
                    roleName: "Self",
                    contactName: this.data?.sender,
                    contactId: Number(contactId),
                    email: currentEmail,
                });
            }

            this.data.reports = [];
            this.data.hasRole = false;
            this.data.isScheduler = false;

            const roles: Partial<EmailRole>[] = S25Util.array.forceArray(eventData.role) || [];

            if (roles.length) {
                const hasRole =
                    S25Util.valueFind(roles, "contact_id", contactId) ||
                    S25Util.valueFind(eventData, "cur_assigned_to_id", contactId) ||
                    S25Util.valueFind(eventData, "cur_assigned_by_id", contactId) ||
                    S25Util.valueFind(eventData, "approval_contact_id", contactId);

                this.data.hasRole = hasRole;

                this.data.isScheduler =
                    hasRole &&
                    roles.some(
                        (role: EmailRole) =>
                            role.role_id === S25Const.schedulerRole.event &&
                            S25Util.valueFind(role, "contact_id", contactId),
                    );

                for (const role of roles) {
                    if (role?.contact) {
                        this.data?.roles.push({
                            roleName: role.role_name,
                            roleId: role.role_id,
                            contactName: role.contact.contact_name,
                            contactId: role.contact.contact_id,
                            email: role.contact.email,
                        });
                    }
                }

                this.data?.roles.push(
                    {
                        text: this.data?.emailLang?.text?.anyone_with_assignments,
                        email: "assigners",
                    },
                    {
                        text: this.data?.emailLang?.text?.task_recipients,
                        email: "service providers",
                    },
                );

                if (this.data?.isScheduler) {
                    this.data?.roles.push({
                        text: this.data?.emailLang?.text?.event_owner,
                        email: "object owner",
                    });
                }
            }

            if (reportsData && this.data) {
                this.data.reports = reportsData;
                const allContracts = [...contracts, ...orgContracts];

                for (let i = this.data.reports.length - 1; i >= 0; i--) {
                    const r = this.data.reports[i];
                    let remove = false;
                    this.assignEmailListKey(r);

                    if (r.rpt_engine === "JR") r.format = 2;

                    if (r.rpt_engine === "DM") {
                        const found = allContracts.find((item) => item.itemName.trim() === r.rpt_name?.trim());
                        if (found) {
                            r.documentId = found.itemId;
                            r.optUUID = found.itemId;
                        } else {
                            remove = true;
                        }
                    }

                    if (r.rpt_use === Report.Use.Confirmation) {
                        r.rpt_name = `Default Confirmation: ${r.rpt_name}`;
                    } else if (r.rpt_use === Report.Use.Invoice) {
                        r.rpt_name = `Default Invoice: ${r.rpt_name}`;
                    }

                    const rptId = r.rpt_id;
                    if (
                        rptId === Report.Reports.ReservationShell.id ||
                        rptId === Report.Reports.EventShell.id ||
                        rptId === Report.Reports.OrganizationShell.id ||
                        r.object_type === Report.ObjectType.PaymentDocument
                    ) {
                        remove = true;

                        if (rptId === Report.Reports.EventShell.id) {
                            for (const c of contracts) {
                                const eventDocumentReport: EmailReportSimpleObject = {
                                    template_id: rptId,
                                    rpt_id: c.reportId || rptId,
                                    rpt_use: r.rpt_use,
                                    rpt_engine: r.rpt_engine,
                                    rpt_name: `Event Document: ${c.itemName}`,
                                    documentId: c.itemId,
                                    optUUID: c.itemId,
                                };
                                this.assignEmailListKey(eventDocumentReport);
                                this.data.reports.push(eventDocumentReport);
                            }
                        }

                        if (rptId === Report.Reports.OrganizationShell.id) {
                            for (const c of orgContracts) {
                                const organizationDocumentReport: EmailReportSimpleObject = {
                                    template_id: rptId,
                                    rpt_id: c.reportId || rptId,
                                    rpt_use: r.rpt_use,
                                    rpt_engine: r.rpt_engine,
                                    rpt_name: `Organization Document: ${c.itemName}`,
                                    documentId: c.itemId,
                                    optUUID: c.itemId,
                                    object_type: Report.ObjectType.OrganizationDocument,
                                };
                                this.assignEmailListKey(organizationDocumentReport);
                                this.data.reports.push(organizationDocumentReport);
                            }
                        }
                    }

                    if (remove) {
                        this.data.reports.splice(i, 1);
                    }
                }
            }

            this.data.init = true;
            this.setLoading(false);
            this.data.ToEmails.action = () => this.appendEmails(this.data.ToEmails);
            this.data.CCEmails.action = () => this.appendEmails(this.data.CCEmails);
            this.data.BCCEmails.action = () => this.appendEmails(this.data.BCCEmails);

            const allEventFiles = eventFiles || [];

            // Split files into normal and custom attribute files
            const [normalFiles, custAttrFiles] = allEventFiles.reduce<[typeof allEventFiles, typeof allEventFiles]>(
                (acc, f) => {
                    const fileWithFlag = { ...f, isChosen: false };
                    if (f.hasOwnProperty("cust_atrb_id")) {
                        acc[1].push(fileWithFlag);
                    } else {
                        acc[0].push(fileWithFlag);
                    }
                    return acc;
                },
                [[], []], // [normalFiles, custAttrFiles]
            );

            // Filter custom attribute files that user has right to view
            const filteredCustAttrFiles = await ObjectDetailsUtil.filterMasterDefinitions(
                "getEventCustomAttributes",
                custAttrFiles,
                "cust_atrb_id",
                [true],
            );
            // Combine both arrays
            this.eventFiles = normalFiles.concat(filteredCustAttrFiles);

            this.emailFields = ["To", "CC", "BCC"].map((label) => {
                const key = label + "Emails";
                return {
                    id: key,
                    label,
                    buttonText: label.toUpperCase(),
                    model: this.data[key as keyof typeof this.data],
                };
            }) as EmailField[];

            this.init = true;
            this.dataSignal.set(this.data);
            this.cd.detectChanges();
        } catch (error) {
            console.error("Initialization failed:", error);
            this.setLoading(false);
        }
    }

    appendEmails(target: EmailsConfig) {
        const selected = target?.addedItems || [];
        target.contactRefsByEmail = target.contactRefsByEmail ?? {};
        for (const item of selected) {
            const email = item.itemDesc?.trim();
            const contactId = item.itemId != null ? Number(item.itemId) : Number.NaN;
            if (email && Number.isFinite(contactId)) {
                target.contactRefsByEmail[email.toLowerCase()] = contactId;
            }
        }
        const emailList = selected
            .map((item) => item.itemDesc)
            .filter(Boolean)
            .join(", ");

        target.emailList = target.emailList ? target.emailList + ", " + emailList : emailList;
    }

    getCleanEmails(emailString: string) {
        return S25Util.array
            .unique(
                emailString
                    .split(/[,\s;]/)
                    .map(S25Util.trim)
                    .filter(S25Util.isTruthy)
                    .filter((token) => S25Util.isValidEmail(token)),
            )
            .join(", ");
    }

    getFinalContactString(emailsConfig: EmailsConfig | undefined, roleChooseProp: keyof EmailRole): string {
        const additionalInputs: EmailRecipientInput[] = (emailsConfig?.emailList ?? "")
            .split(/[,;]/)
            .map(S25Util.trim)
            .filter(S25Util.isTruthy)
            .map((token) => {
                const contactId = emailsConfig?.contactRefsByEmail?.[token.toLowerCase()];
                return contactId != null ? { contId: contactId, email: token } : token;
            });

        const roleInputs: EmailRecipientInput[] = [];
        for (const role of this.data.roles ?? []) {
            if (!role[roleChooseProp]) {
                continue;
            }
            if (role.contactId != null && Number.isFinite(role.contactId)) {
                roleInputs.push({ contId: role.contactId, email: role.email });
            } else if (role.email) {
                roleInputs.push(role.email);
            }
        }

        return EmailService.joinRecipientRefs([...additionalInputs, ...roleInputs]);
    }

    getReportRunItemID() {
        this.reportsEventContractIsChosen = this.data?.reports?.filter((obj: EmailReportObject) => {
            return obj.isChosen && (obj.template_id === -198 || obj.template_id === -217 || obj.rpt_engine === "DM"); // ANG-5852 DM
        }) as EmailReportSimpleObject[];

        const getEventDocumentRunId: EmailReportSimpleObject[] = [];
        if (this.reportsEventContractIsChosen.length > 0) {
            this.reportsEventContractIsChosen.forEach((report: EmailReportSimpleObject) => {
                DocumentService.getEventDocumentRun(report.documentId as number, this.itemId as number).then(
                    ({ id: resp, filename }) => {
                        getEventDocumentRunId.push({
                            template_id: report.template_id,
                            rpt_id: report.rpt_id,
                            rpt_use: report.rpt_use,
                            rpt_engine: report.rpt_engine,
                            rpt_name: report.rpt_name,
                            params: report.params,
                            documentId: report.documentId,
                            optUUID: report.optUUID,
                            itemID: resp,
                            isChosen: true,
                            rpt_filename_runtime: report?.rpt_filename_runtime || filename,
                        });

                        if (getEventDocumentRunId.length === this.reportsEventContractIsChosen.length) {
                            this.reportsEventContractIsChosen = getEventDocumentRunId;
                            this.send();
                        }
                    },
                );
            });
        } else {
            this.send();
        }
    }

    send() {
        this.disabled = true;
        try {
            setTimeout(() => {
                //ANG-2674: wait timeout to allow model to update in case ngModel update was missed somehow
                const from = this.data?.fromEmail;
                const tos = this.getFinalContactString(this.data?.ToEmails, "isChosenTo");
                const ccs = this.getFinalContactString(this.data?.CCEmails, "isChosenCC");
                const bccs = this.getFinalContactString(this.data?.BCCEmails, "isChosenBCC");
                const reportsIsChosen = this.data?.reports?.filter(
                    (obj: EmailReportObject) =>
                        obj.isChosen && obj.template_id !== -198 && obj.template_id !== -217 && obj.rpt_engine !== "DM",
                );

                const reports = reportsIsChosen.concat(this.reportsEventContractIsChosen) as EmailReport[];

                let webServiceFiles = this.data?.iCalReport
                    ? [DataAccess.getUrl(`/event.ics?event_id=${this.itemId}&session_id=${this.data?.sessionId}`)]
                    : [];

                const uploadedFiles: { name: string; data: string }[] =
                    this.data?.files
                        ?.filter((obj) => obj.isChosen)
                        .map((obj) => ({
                            name: obj.name,
                            data:
                                typeof obj.data === "string"
                                    ? obj.data
                                    : btoa(String.fromCharCode(...new Uint8Array(obj.data))),
                        })) ?? [];

                const eventFiles: string[] = this.eventFiles.filter((f) => f.isChosen).map((f) => f.itemName);

                //eventFiles payload same as  webservices, so push eventFiles to webServiceFiles
                if (eventFiles.length > 0) webServiceFiles = webServiceFiles.concat(eventFiles);

                const emailBody = EventEmailService.formEventEmail(
                    this.data?.bodyMsg ?? "",
                    this.data?.sender ?? "",
                    this.data?.isIncludeDetails ?? false,
                    this.data?.eventData,
                    this.itemId ?? 0,
                    this.data?.dateFormat,
                    this.data?.timeFormat,
                    S25Const.baseUrl,
                    this.data?.emailLang,
                    this.data?.eventLinkFormat,
                    this.data?.chosenTemplate?.itemId,
                );

                if (this.isScheduled) {
                    TelemetryService.sendWithSub("EventDetails", "Email", "Schedule");
                }

                const emailPromise = EmailService.sendEmail(
                    this.data?.subject ?? "",
                    emailBody,
                    tos,
                    from,
                    ccs,
                    bccs,
                    reports,
                    webServiceFiles,
                    uploadedFiles,
                    this.itemId,
                    1,
                    this.data?.chosenTemplate?.itemId || 0,
                    {
                        itemId: 0,
                        isScheduled: this.isScheduled,
                        scheduleType: this.scheduleType,
                        scheduleDays: this.scheduleDays,
                    },
                    S25Util.generateQuickGUID(),
                    this.isConvo ? true : undefined,
                )
                    .then((resp) => {
                        if (resp && resp.error) {
                            NotificationService.post("Email(s) failed: " + resp.error);
                            this.disabled = false;
                        } else {
                            NotificationService.post("Email(s) have been successfully sent");
                            this.cancel();
                        }
                    })
                    .catch((resp) => {
                        NotificationService.post("Email(s) failed: " + S25Util.errorText(resp, "Uncaught Error"));
                        this.disabled = false;
                    });
                NotificationService.post("Email(s) are sending...", emailPromise);
            }, 250);
        } catch (e) {
            NotificationService.post("Email(s) failed: " + (e.message || "Uncaught Error"));
        }
    }

    onScheduledChange(isScheduled: 0 | 1): void {
        if (isScheduled) {
            this.isConvo = 0;
        }
    }

    cancel() {
        this.closed.emit();
        this.data.chosenTemplate = undefined;
        this.data.subject = this.data?.subjectClean || "";
        this.data.bodyMsg = "";

        this.disabled = false;
        this.data.fromEmail = "";
        this.data.ToEmails.emailList = this.getCleanEmails("");
        this.data.CCEmails.emailList = this.getCleanEmails("");
        this.data.BCCEmails.emailList = this.getCleanEmails("");
        this.data.ToEmails!.contactRefsByEmail = {};
        this.data.CCEmails!.contactRefsByEmail = {};
        this.data.BCCEmails!.contactRefsByEmail = {};

        this.data.eventLinkFormat = "pro";
        this.data.includeLink = true;
        this.data.isIncludeDetails = false;
        this.data.iCalReport = false;

        this.data?.roles?.forEach((role) => {
            role.isChosenTo = false;
            role.isChosenCC = false;
            role.isChosenBCC = false;
        });

        this.data?.reports?.forEach((report) => {
            report.isChosen = false;
        });

        this.data.files = [];
    }

    async chooseTemplate(): Promise<void> {
        try {
            this.setLoading(true);

            const eventData = await BpeService.getEventData(this.itemId as number, { cache: true, longCache: true });
            await BpeService.getAdditionalEventData({ postEventDataPromise: Promise.resolve(eventData) });

            const email = await BpeService.getEmailObjectFromTemplate(
                eventData,
                this.data.chosenProfile.profile_id === -999 ? null : this.data.chosenProfile.profile_id,
                this.data?.chosenTemplate,
            );

            // Add "object owner" role if referenced in email and user is not scheduler
            if (
                !this.data?.isScheduler &&
                ["to", "cc", "bcc"].some((field) => (email[field] || "").includes("object owner"))
            ) {
                S25Util.array.inplacePushByProp(this.data?.roles, "email", "objectOwner", {
                    text: this.data?.emailLang?.text?.event_owner,
                    email: "object owner",
                });
            }

            // Reset all roles and assign based on email
            this.data?.roles?.forEach((r) => {
                r.isChosenTo = false;
                r.isChosenCC = false;
                r.isChosenBCC = false;

                const role = r.text ? r.email : r.roleName;
                const regex = new RegExp(`${role}($|[,;'"\s])`, "i");

                r.isChosenTo = regex.test(email.to || "");
                r.isChosenCC = regex.test(email.cc || "");
                r.isChosenBCC = regex.test(email.bcc || "");
            });

            // Populate email fields
            this.data.fromEmail = email.from;
            this.data.showFrom = !!(this.data?.fromEmail && this.data?.canFrom);
            this.data.ToEmails.emailList = this.getCleanEmails(email.to || "");
            this.data.CCEmails.emailList = this.getCleanEmails(email.cc || "");
            this.data.BCCEmails.emailList = this.getCleanEmails(email.bcc || "");
            this.data.ToEmails!.contactRefsByEmail = {};
            this.data.CCEmails!.contactRefsByEmail = {};
            this.data.BCCEmails!.contactRefsByEmail = {};
            this.data.subject = S25Util.unescapeXml(email.subject || "");
            this.data.bodyMsg = email.body || "";
            this.data.isIncludeDetails = false;
            this.data.iCalReport = this.data?.chosenTemplate?.iCalFile === 1;

            // Handle reports
            const reportTokens: string[] = email.reports?.split(",").map((s: string) => s.trim()) || [];
            const reportsHash: Record<string, boolean> = {};
            const eventTypeReports = this.data?.eventTypeReports ?? [];

            const sortedReports = [...(this.data?.reports ?? [])].sort(S25Util.shallowSort("rpt_use", true, true));

            sortedReports.forEach((r) => {
                r.isChosen = false;

                for (const token of reportTokens) {
                    if (reportsHash[token]) continue;

                    const tokenId = parseInt(token);
                    const isConfirmation = token === "confirmation" && parseInt(r.rpt_use) === 1;
                    const isInvoice = token === "invoice" && parseInt(r.rpt_use) === 2;
                    const idMatch = !isNaN(tokenId) && tokenId === parseInt(r.rpt_id);
                    const eventMatch = eventTypeReports.some(
                        (et: EmailReportObject) => tokenId === et.report_id && parseInt(r.rpt_id) === et.report_id,
                    );

                    if (isConfirmation || isInvoice || idMatch || eventMatch) {
                        r.isChosen = true;
                        reportsHash[token] = true;
                    }
                }
            });
        } catch (error) {
            console.error("Failed to choose template:", error);
            NotificationService.post("Failed to load email template: " + (error.message || "Unknown error"));
        } finally {
            this.setLoading(false);
        }
    }

    addFrom() {
        this.data.showFrom = true;
    }

    chooseProfile() {
        if (this.data?.chosenProfile && this.data?.chosenTemplate) {
            return this.chooseTemplate();
        }
    }

    onLinkChange(data: boolean) {
        if (!data) {
            this.data.eventLinkFormat = "noLink";
        } else {
            this.data.eventLinkFormat = "pro";
        }
    }

    onReportChosenChange(report: EmailReportObject, isChosen: boolean): void {
        // When unchecked and report engine is JR, reset filename and format to PDF
        if (!isChosen && (report.rpt_engine === "JR" || report.report_engine === "JR")) {
            // Reset format to PDF (2)
            report.format = ReportFormat.PDF;

            if (report.rpt_filename_runtime) {
                // Reset filename to PDF extension
                report.rpt_filename_runtime = this.updateOuputFilenameExtension(
                    report.rpt_filename_runtime,
                    ReportFormat.PDF, // PDF format
                );
            }

            // Update the data signal to trigger reactivity
            this.dataSignal.set({ ...this.data });
            this.cd.detectChanges();
        }
    }

    onReportFormatChange(data: EmailReportObject & { reportId?: number }): void {
        if (!this.data?.reports || data?.reportId == null) return;

        const reports = [...this.data.reports];

        const target = this.findReportByListKey(data.reportId, reports);
        if (!target) return;

        // update format
        target.format = data.formatType;

        // update output filename if it exists
        if (target.rpt_filename_runtime) {
            target.rpt_filename_runtime = this.updateOuputFilenameExtension(
                target.rpt_filename_runtime,
                data.formatType,
            );
        }
        // update data
        this.data.reports = reports as EmailReportObject[];
        this.onChange();
    }

    onReportFilenameChange(data: { reportId: number; outputFileName: string }): void {
        if (!this.data?.reports || data.reportId == null) return;

        const reports = [...this.data.reports];
        const target = this.findReportByListKey(data.reportId, reports);
        if (!target) return;

        target.rpt_filename_runtime = data.outputFileName;
        this.data.reports = reports as EmailReportObject[];
        this.onChange();
    }

    onReportOrgChange(report: Report.Object) {
        const reports = this.data?.reports || [];
        for (let i = 0; i < reports?.length; i++) {
            if (reports[i].rpt_id === report.rpt_id) {
                //Once we send an org_id parameter we need to also include the eventId as a parameter for emails
                if (report.orgId) {
                    reports[i].params = reports[i].params || {};
                    Object.assign((reports[i].params ??= {}), {
                        num_parm4: report.orgId,
                        num_parm1: this.itemId,
                    });
                } else if (reports[i]?.params) {
                    //fall back to no special report parameters
                    delete reports[i].params;
                }
                break;
            }
        }
    }

    handleFileUpload = async (file: S25File): Promise<void> => {
        this.data.files.push(file);
    };

    setLoading(yes: boolean) {
        if (yes) {
            S25LoadingApi.init(this.elementRef.nativeElement);
        } else {
            S25LoadingApi.destroy(this.elementRef.nativeElement);
        }
        this.cd.detectChanges();
    }

    // Create a computed signal that maps each attach-list row to its filename
    reportFilenamesMap = computed(() => {
        const data = this.dataSignal();
        const reports = data?.reports || [];
        const eventTypeReports = data?.eventTypeReports || [];
        const map = new Map<number, string>();

        reports.forEach((report) => {
            const listKey = report.emailListKey;
            if (!listKey) return;

            if (report.rpt_filename_runtime) {
                map.set(listKey, report.rpt_filename_runtime);
                return;
            }

            const eventTypeReport = eventTypeReports.find(
                (candidate) => Number(candidate.report_id) === Number(report.rpt_id),
            );
            const contentDisposition = eventTypeReport?.content_disposition ?? "";
            const fileName = ReportService.extractsFilename(contentDisposition);
            if (fileName) {
                map.set(listKey, fileName);
            }
        });

        return map;
    });

    getReportOutputFilename(emailListKey: number): string {
        return this.reportFilenamesMap().get(emailListKey) || "";
    }

    private assignEmailListKey(report: EmailReportSimpleObject): void {
        report.emailListKey ??= ++this.emailReportKeySeq;
    }

    private findReportByListKey(
        emailListKey: number,
        reports: Array<EmailReportObject | EmailReportSimpleObject> = this.data?.reports ?? [],
    ): (EmailReportObject | EmailReportSimpleObject) | undefined {
        return reports.find((report) => report.emailListKey === emailListKey);
    }

    updateOuputFilenameExtension(fileName: string, formatType: number): string {
        let ext = "pdf";
        switch (formatType) {
            case ReportFormat.HTML:
                ext = "html";
                break;
            case ReportFormat.Text:
                ext = "txt";
                break;
            case ReportFormat.Excel:
                ext = "xls";
                break;
            case ReportFormat.RichText:
                ext = "rtf";
                break;
        }
        // no extension → append new one
        if (!fileName.includes(".")) {
            return fileName + "." + ext;
        }
        return fileName.replace(/\.[^/.]+$/, "." + ext);
    }

    onChange() {
        this.dataSignal.set({ ...this.data });
        this.cd.detectChanges();
    }
}
